import { CliVerificationMethod, CliVerificationStatus } from './cli-verification.model';
import { ScheduleOptionValueEnum } from './schedule-option.model';
import { FormControl, FormGroup } from '@angular/forms';
import { I18nKeys } from './i18n.model';
import { Dayjs } from 'dayjs';

export interface FormfieldValuesDTO {
	documentId?: number;
	name: string;
	value: string | null;
	type?: string;
	valid?: boolean;
	abDetailType: string | null;
	callReason?: string;
}

export interface TelephoneNumberDTO {
	number: string;
	type: number;
}

export enum GenderEnum {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export interface PrefixData {
	male: string;
	female: string;
	neutral: string;
}

export interface CallerDTO {
	salutation: string;
	firstname: string;
	lastname: string;
	company: string | null;
	contact: string | null;
	isVip: boolean;
	telephoneNumbers: TelephoneNumberDTO[];
	gender: GenderEnum | null;
}

export interface BusinessHourDTO {
	day: string;
	start: string;
	end: string;
}

export type TranslationDTO = {
	[key: string]: I18n;
};

export interface I18n {
	general: {
		cancel: {
			translation: string;
			fallback: string | null;
		};
		error_invalid_date: {
			translation: string;
			fallback: string | null;
		};
		error_no_business_day: {
			translation: string;
			fallback: string | null;
		};
		error_past_date: {
			translation: string;
			fallback: string | null;
		};
		error_required: {
			translation: string;
			fallback: string | null;
		};
		error_max_length: {
			translation: string;
			fallback: string | null;
		};
		label_friday: {
			translation: string;
			fallback: string | null;
		};
		label_monday: {
			translation: string;
			fallback: string | null;
		};
		label_saturday: {
			translation: string;
			fallback: string | null;
		};
		label_sunday: {
			translation: string;
			fallback: string | null;
		};
		label_thursday: {
			translation: string;
			fallback: string | null;
		};
		label_tuesday: {
			translation: string;
			fallback: string | null;
		};
		label_wednesday: {
			translation: string;
			fallback: string | null;
		};
		no: {
			translation: string;
			fallback: string | null;
		};
		new_function: {
			translation: string;
			fallback: string | null;
		};
		ok: {
			translation: string;
			fallback: string | null;
		};
		yes: {
			translation: string;
			fallback: string | null;
		};
	};
	callnote: {
		the_caller: {
			translation: string;
			fallback: string | null;
		};
		caller_numbers: {
			translation: string;
			fallback: string | null;
		};
		call_label: {
			translation: string;
			fallback: string | null;
		};
		contextHeader: {
			translation: string;
			fallback: string | null;
		};
		label_ansprechpartner: {
			translation: string;
			fallback: string | null;
		};
		teletype_additional: {
			translation: string;
			fallback: string | null;
		};
		teletype_biz: {
			translation: string;
			fallback: string | null;
		};
		teletype_email_additional: {
			translation: string;
			fallback: string | null;
		};
		teletype_email_biz: {
			translation: string;
			fallback: string | null;
		};
		teletype_email_main: {
			translation: string;
			fallback: string | null;
		};
		teletype_email_private: {
			translation: string;
			fallback: string | null;
		};
		teletype_fax_additional: {
			translation: string;
			fallback: string | null;
		};
		teletype_fax_biz: {
			translation: string;
			fallback: string | null;
		};
		teletype_fax_main: {
			translation: string;
			fallback: string | null;
		};
		teletype_fax_private: {
			translation: string;
			fallback: string | null;
		};
		teletype_main: {
			translation: string;
			fallback: string | null;
		};
		teletype_mobile: {
			translation: string;
			fallback: string | null;
		};
		teletype_phone_additional: {
			translation: string;
			fallback: string | null;
		};
		teletype_private: {
			translation: string;
			fallback: string | null;
		};
	};
	outbound_task: {
		accept_voicemail: {
			translation: string;
			fallback: string | null;
		};
		alternative_suggestions: {
			translation: string;
			fallback: string | null;
		};
		business_hour: {
			translation: string;
			fallback: string | null;
		};
		call_btn: {
			translation: string;
			fallback: string | null;
		};
		callback_condition: {
			translation: string;
			fallback: string | null;
		};
		callback_confirmation: {
			translation: string;
			fallback: string | null;
		};
		callback_error: {
			translation: string;
			fallback: string | null;
		};
		callback_prompt: {
			translation: string;
			fallback: string | null;
		};
		callback_request_generated: {
			translation: string;
			fallback: string | null;
		};
		callback_question: {
			translation: string;
			fallback: string | null;
		};
		callback_question_content: {
			translation: string;
			fallback: string | null;
		};
		callback_question_end: {
			translation: string;
			fallback: string | null;
		};
		callback_question_time: {
			translation: string;
			fallback: string | null;
		};
		callback_schedule: {
			translation: string;
			fallback: string | null;
		};
		callback_success: {
			translation: string;
			fallback: string | null;
		};
		callback_suggestions_label: {
			translation: string;
			fallback: string | null;
		};
		callback_time_asap: {
			translation: string;
			fallback: string | null;
		};
		callback_time_information: {
			translation: string;
			fallback: string | null;
		};
		contact_us_option: {
			translation: string;
			fallback: string | null;
		};
		error_callback_request: {
			translation: string;
			fallback: string | null;
		};
		earliest: {
			translation: string;
			fallback: string | null;
		};
		existing_outbound_task_in_progress_warn: {
			translation: string;
			fallback: string | null;
		};
		existing_outbound_task_scheduled_warn: {
			translation: string;
			fallback: string | null;
		};
		no_generated_suggestions: {
			translation: string;
			fallback: string | null;
		};
		page_title: {
			translation: string;
			fallback: string | null;
		};
		prefix_female: {
			translation: string;
			fallback: string | null;
		};
		prefix_male: {
			translation: string;
			fallback: string | null;
		};
		prefix_neutral: {
			translation: string;
			fallback: string | null;
		};
		schedule_business_hours: {
			translation: string;
			fallback: string | null;
		};
		schedule_next_available_time: {
			translation: string;
			fallback: string | null;
		};
		schedule_no_business_hours: {
			translation: string;
			fallback: string | null;
		};
		schedule_out_of_business_hours: {
			translation: string;
			fallback: string | null;
		};
		select_callback_number: {
			translation: string;
			fallback: string | null;
		};
		the_caller: {
			translation: string;
			fallback: string | null;
		};
		time_warning: {
			translation: string;
			fallback: string | null;
		};
		outbound_info_title: {
			translation: string;
			fallback: string | null;
		};
		outbound_info_description: {
			translation: string;
			fallback: string | null;
		};
		outbound_price_title: {
			translation: string;
			fallback: string | null;
		};
		outbound_price_description: {
			translation: string;
			fallback: string | null;
		};
		info_price_btn: {
			translation: string;
			fallback: string | null;
		};
		make_call: {
			translation: string;
			fallback: string | null;
		};
	};
	feedback?: {
		[key: string]: {
			translation: string;
			fallback: string | null;
		};
	};
	caller_correction?: {
		[key: string]: {
			translation: string;
			fallback: string | null;
		};
	};
}

export interface AiInstruction {
	id: number;
	suggestion: string;
}

export interface OutgoingNumberDTO {
	name: string;
	number: string;
}

export interface ExistingOutboundTaskDTO {
	status: string;
	notBefore: string | null;
	nextAttempt: string | null;
}

export interface CallbackOnCallNoteDTO {
	languageId: number;
	timeZone: string;
	callNote: {
		processingStart: string;
		subject: string;
		message: string | null;
		callReason: string | null;
		formfieldValues: FormfieldValuesDTO[];
		caller: CallerDTO;
		syncedWithAddressBook?: boolean;
	};
	callReasonId: number | null;
	instructionSuggestions: AiInstruction[];
	existingOutboundTask: ExistingOutboundTaskDTO | null;
	businessHours: BusinessHourDTO[];
	outboundOutgoingPhoneNumber: string | null;
	availableOutgoingNumbers?: OutgoingNumberDTO[];
	bookableLocations?: string[];
	translations: TranslationDTO;
	/**
	 * PS-6646 — the phone service this callnote belongs to. The guided setup refuses a sign-in whose
	 * token resolves to any other one. Optional, because a document-api from before PS-6646 does not
	 * send it - and the setup treats absent as "cannot tell whose it is" and stops.
	 */
	phoneServiceId?: number | null;
	/**
	 * Available "who handles the call" modes for this phone service (EB-4016).
	 * Present/non-empty only in the voicebot case → drives whether the selector is shown.
	 */
	voiceBotModeOptions?: VoiceBotMode[];
	/**
	 * PS-6494 — whether the phone service can place calls at all. Both false means no SIP-Account
	 * exists, which PS-6495 turns into the guided setup. Verified present in a live response
	 * (2026-09-04): the backend has delivered these since PS-6494; only this interface was missing
	 * them. Optional, because a payload from before that release carries neither — and PS-6495
	 * deliberately treats absent as "do not offer the chargeable order".
	 */
	hasSipNumber?: boolean;
	hasSipExtension?: boolean;
	/**
	 * PS-6526 (delivered 2026-09-21) — the monthly fee of the SIPTrunk extension on the plan the
	 * customer's contract currently runs on, and the currency of the contract holder's brand.
	 *
	 * Both are always present in the payload and are populated regardless of `hasSipExtension`, so
	 * a customer who already owns the product still receives the price and simply ignores it.
	 *
	 * Reading them is not obvious — these rules are the backend's, not ours:
	 * - price `0` + currency: a REAL free offer. Render it; suppressing it would hide a valid offer.
	 * - price `null`: the extension is **not on offer** (plan does not carry it, or the fee could
	 *   not be resolved upstream — the backend cannot distinguish the two). Hide the offer rather
	 *   than showing it without a figure.
	 * - currency `null`: the brand could not be read. Render no price even though one is present.
	 * - **Never default the currency.** Brands bill in EUR, GBP, CHF, THB and JPY; a defaulted one
	 *   would put a legally wrong figure in front of a customer.
	 *
	 * This replaced the provisional `sipAccountMonthlyCost` string. Formatting is ours now — see
	 * `formatMonthlyPrice`.
	 */
	sipExtensionPrice?: number | null;
	currency?: string | null;
	/**
	 * Whether `outboundOutgoingPhoneNumber` is proven to belong to this customer (§120 TKG), as
	 * document-api reads it from phoneservice. `null` when no number is configured OR phoneservice
	 * could not be reached - not the same as NONE.
	 */
	cliVerificationStatus?: CliVerificationStatus | null;
	/** How a VERIFIED status came about. GRANDFATHERED numbers signal even without the SIP trunk. */
	cliVerificationMethod?: CliVerificationMethod | null;
	/** Preselected mode; `null` = inherit the phone service default. */
	defaultVoiceBotMode?: VoiceBotMode | null;
}

/**
 * M: Montag, Mittwoch			- Monday, Wednesday
 * D: Dienstag, Donnerstag,		- Tuesday, Thursday
 * F: Freitag					- friday
 * S: Samstag, Sonntag			- saturday, sunday
 */
export type DayKey = 'M' | 'D' | 'F' | 'S';

export const orderedDays: DayKey[] = ['M', 'D', 'M', 'D', 'F', 'S', 'S'];

export interface TimeParts {
	hour: number;
	minute: number;
}

export const normalCallbackTimes: { startTime: TimeParts; endTime: TimeParts } = {
	startTime: {
		hour: 8,
		minute: 0,
	},
	endTime: {
		hour: 20,
		minute: 0,
	},
};

export class DailyBusinessHour {
	label: string;
	startTime: string;
	endTime: string;
	startHour: number;
	endHour: number;
	startMinute: number;
	endMinute: number;

	constructor(label: string, startTime: Dayjs, endTime: Dayjs) {
		this.label = label;
		this.startTime = startTime.format('HH:mm');
		this.endTime = endTime.format('HH:mm');
		this.startHour = startTime.hour();
		this.startMinute = startTime.minute();
		this.endHour = endTime.hour();
		this.endMinute = endTime.minute();
	}
}

export interface BusinessHoursOverview {
	dailyBusinessHour: (null | DailyBusinessHour)[];
	optimizedInformation: string[];
	tooltip: string;
}

export type EXECUTION_MODE = 'IMMEDIATE' | 'STRICT_SCHEDULE' | 'LOOSE_SCHEDULE' | 'ANYTIME';

/**
 * Who takes the call first (EB-4016). A technical mode key from the backend voicebot-mode
 * lookup table (e.g. `ALWAYS_AI` / `ALWAYS_HUMAN`). Kept as an OPEN string — these are
 * DB-managed dynamic values, so we must not hardcode them as a union (global rule #5).
 */
export type VoiceBotMode = string;

export interface CallbackOnCallNoteRequestDTO {
	voicemailAllowed: boolean;
	executionMode: EXECUTION_MODE;
	notBefore: Date | string | null;
	person: {
		salutation: string;
		firstName: string;
		lastName: string;
		company: string;
	};
	targetPhoneNumbers: string[];
	instructions: string;
	outgoingNumber: string;
	requestContactForBookingNumber: boolean;
	/** Chosen first responder (EB-4016). Omitted when not a voicebot case; `null` = inherit PS default. */
	voiceBotMode?: VoiceBotMode | null;
}

export interface CallbackFormData {
	customSuggestion: string;
	aiSuggestion: number | null;
	selectedScheduleOption: ScheduleOptionValueEnum;
	schedule: {
		time: Date;
		date: Date;
	};
	outboundOutgoingNumber: string;
	requestContactForBookingNumber: boolean;
	voicemailAllowed: boolean;
	voiceBotMode: VoiceBotMode | null;
}

export interface CallbackForm {
	customSuggestion: FormControl<string>;
	aiSuggestion: FormControl<number | null>;
	selectedScheduleOption: FormControl<ScheduleOptionValueEnum>;
	schedule: FormGroup<ScheduleFormGroup>;
	outboundOutgoingNumber: FormControl<string>;
	requestContactForBookingNumber: FormControl<boolean>;
	voicemailAllowed: FormControl<boolean>;
	voiceBotMode: FormControl<VoiceBotMode | null>;
}

export interface ScheduleFormGroup {
	time: FormControl<Date>;
	date: FormControl<Date>;
}

export const dayI18nKeys: string[] = [
	I18nKeys.MONDAY,
	I18nKeys.TUESDAY,
	I18nKeys.WEDNESDAY,
	I18nKeys.THURSDAY,
	I18nKeys.FRIDAY,
	I18nKeys.SATURDAY,
	I18nKeys.SUNDAY,
];
